import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import getLandingPage from 'selectors/getLandingPage';
import setInnerHTML from 'utils/setInnerHTML';
import Thumbnail from 'components/thumbnail';
import Link from 'components/link';
import { CONTENT_ITEM, POST } from 'config/types/prop';
import withStyles from 'isomorphic-style-loader/withStyles';
import withThemes from 'components/hoc/withThemes';
import I18n from 'components/i18n';
import getIsInProductMagazine from 'selectors/getIsInProductMagazine';
import SearchListViewItem from './search';

import defaultTheme from './listViewItem.css';
import twoUp from './twoUp.css';
import threeUp from './threeUp.css';
import linear from './linear.css';

const DefaultListViewItem = ({
  item,
  theme,
  themeName,
  isLandingPage,
  topTwoArticles,
  isInProductMagazine,
}) => {
  const {
    id,
    title,
    excerpt,
    metadata: {
      featuredImageUrl,
      coauthors: [{ // Always use the first coauthor
        relativePath,
        displayName,
      }],
      link,
    },
  } = item;
  const isTopTwoArticles = topTwoArticles.some((topArticle) => topArticle.id === id);
  const isTwoUpTheme = 'twoUp' === themeName;
  const imagePosition = `${themeName}ListView`;

  if ('linear' === themeName) {
    return <SearchListViewItem item={item} theme={theme} />;
  }

  return (
    <div className={classNames(theme.wrapper, {
      [theme.noImage]: !featuredImageUrl,
    })}
    >
      <Link to={link} className={theme.link}>
        {featuredImageUrl && <div className={theme.featuredImageWrapper}>
          <Thumbnail
            alt={title}
            isLazyLoading={isLandingPage ? !isTopTwoArticles : !isTwoUpTheme}
            originalSource={featuredImageUrl}
            position={imagePosition}
            wrapperClasses={theme.featuredImage}
          />
        </div>}
        <div className={theme.content}>
          <h3
            className={theme.heading}
            dangerouslySetInnerHTML={setInnerHTML(title)} // eslint-disable-line react/no-danger
          />
        </div>
      </Link>
      <div
        className={theme.excerpt}
        dangerouslySetInnerHTML={setInnerHTML(excerpt)} // eslint-disable-line react/no-danger
      />
      <div className={theme.author}>
        <span>
          <I18n
            field="by"
            defaultText="by"
          />
          {isInProductMagazine ?
            ` ${displayName}` :
            <Link to={relativePath}> {displayName}</Link>
          }
        </span>
      </div>
    </div>
  );
};

DefaultListViewItem.propTypes = {
  isLandingPage: PropTypes.bool.isRequired,
  item: PropTypes.shape(POST).isRequired,
  theme: PropTypes.object.isRequired,
  themeName: PropTypes.string.isRequired,
  topTwoArticles: PropTypes.arrayOf(
    PropTypes.shape(CONTENT_ITEM),
  ).isRequired,
  isInProductMagazine: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const landingPage = getLandingPage(state);
  let topTwoArticles = [];

  if (landingPage) {
    topTwoArticles = landingPage.relatedItems.slice(0, 2);
  }

  return {
    isLandingPage: Boolean(landingPage),
    topTwoArticles,
    isInProductMagazine: getIsInProductMagazine(state),
  };
};

const withRedux = connect(mapStateToProps);
const wrapWithStyles = withStyles(defaultTheme, twoUp, threeUp, linear);
const wrapWithThemes = withThemes(
  'DefaultListViewItem',
  { defaultTheme, twoUp, threeUp, linear },
  true,
);

export default withRedux(wrapWithStyles(wrapWithThemes(DefaultListViewItem)));
